<template>
    <nav id="UiLayer">
        <Logo v-show="!shouldHideLoge"></Logo>
        <transition name="fade">
            <BackButton :class="{ 'fade-when-home': !this.showBackBtn }" v-show="showBackBtn"></BackButton>
        </transition>
        <FullscreenButton></FullscreenButton>
        <transition name="fade">
            <ShareButton v-if="showShareBtn"></ShareButton>
        </transition>
        <transition name="fade">
            <div class="bottom-line" v-show="!isComponentOpen">
                {{ globalData?.data?.tagline }}
            </div>
        </transition>
    </nav>
</template>
<script>
import Logo from "../ui/Logo.vue";
import Breadcrumbs from "../ui/Breadcrumbs.vue";
import BackButton from "../ui/BackButton.vue";
import AudioToggle from "../ui/AudioToggle.vue";
import FullscreenButton from "../ui/FullscreenButton.vue";
import ShareButton from '../ui/ShareButton.vue'

export default {
    components: {
        // Ui Components
        Logo,
        Breadcrumbs,
        BackButton,
        AudioToggle,
        FullscreenButton,
        ShareButton
    },
    data() {
        return {
            globalData: undefined
        };
    },
    mounted() {
        this.globalData = app.api.PageManager.getCustomComponentFromType('globalData');
    },
    methods: {},
    computed: {
        onHomePage() {
            this.$route;

            return app.api.PageManager.onHomePage();
        },
        isComponentOpen() {
            this.$route;
            return app.api.PageManager.getIsContentComponentOpen();
        },
        getMaximizedSizeAndOffset() {
            return this.$store.getters.getMaximizedSizeAndOffsetValue;
        },
        showBackBtn() {
            if (this.isComponentOpen) return true;
            if (!this.onHomePage) return true;
            return false;
        },
        showShareBtn() {
            if (this.isComponentOpen) return true;
            return false;
        },
        shouldHideLoge() {
            if (this.$store.getters.getHideLogo) return true;



            this.$route
            var hasFullscreenComponent = false;

            if (!this.isComponentOpen) return hasFullscreenComponent;


            var fullscreenComponents = [''];
            var openComponents = app.api.PageManager.getOpenContentComponents();
            var i = 0;

            while (i < openComponents.length) {
                if (fullscreenComponents.includes(openComponents[i].type)) {
                    hasFullscreenComponent = true
                }
                i++
            }
            return hasFullscreenComponent;

        }
    }
};
</script>

<style lang="scss">
#UiLayer {
    position: absolute;
    z-index: 10;
    top: 0;
    width: 100%;
    max-width: 1920px;
    height: 100%;
    pointer-events: none;

    * {
        pointer-events: all;
    }

    .bottom-line {
        font-family: 'Montserrat';
        position: absolute;
        height: 50px;

        left: var(--page-margin);
        right: var(--page-margin);
        bottom: 55px;
        border-radius: 100px;

        display: flex;
        align-items: center;
        justify-content: center;

        color: white;
        font-weight: 600;
        font-size: 18px;
        text-transform: uppercase;

        pointer-events: none;
        z-index: -1;

        &::before {
            content: '';
            position: absolute;
            height: 49px;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            background-color: var(--black);
            width: 100%;
            z-index: -1;
            opacity: .4;

            border-radius: 100px;
        }
    }
}
</style>